import React from 'react'

import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import { yesno } from 'src/helpers/displayhelpers'
import { ContractOnboardingById } from 'src/queries'

interface ListProps {
  contract: ContractOnboardingById | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { contract } = props
  const onboarding = contract?.onboarding ?? {}
  const section: Array<Omit<ItemProps, 'id'>> = [
    { title: 'Onboarding Days', value: onboarding.days },
    { title: 'Clearance Reqs', value: yesno(onboarding.clearanceReqs) },
    { title: 'BI Process Timeframe', value: onboarding.biProcessTimeframe },
    { title: 'GFE Provided', value: yesno(onboarding.gfeProvided) },
    { title: 'IMC IT Equipment Provided', value: yesno(onboarding.imcEquipment) }
  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: contract === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <DescriptionList {...dlProps}>
      {section.map(item => {
        const key = item.title.toLowerCase().replace(' ', '-')
        return <Item {...item} key={key} id={key} />
      })}
    </DescriptionList>
  )
}

export default List
